import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FaIcon } from "../FaIcon";
import { SyncConfigurationForm } from "./SyncConfigurationForm";
import { withTranslation } from 'react-i18next';

class SyncConfigurationModalClass extends Component {
    render() {
        const { isOpen, toggle, onSave, syncConfiguration, isCopying, t } = this.props;
        const isEditing = !!syncConfiguration && !isCopying;

        let title = t('sync_configuration_modal.new_sync');
        if (isEditing) {
            title = t('sync_configuration_modal.edit_sync');
        } else if (isCopying) {
            title = t('sync_configuration_modal.copy_sync');
        }

        const icon = isEditing ? "pencil-alt" : (isCopying ? "copy" : "table");

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered modal-xl sync-config-modal">
                <ModalHeader toggle={toggle}><FaIcon iconName={icon} /> {title}</ModalHeader>
                <ModalBody>
                    <SyncConfigurationForm
                        closeModal={toggle}
                        afterSubmit={onSave}
                        syncConfiguration={syncConfiguration}
                        isCopying={isCopying}
                    />
                </ModalBody>
            </Modal>
        );
    }
}

export const SyncConfigurationModal = withTranslation()(SyncConfigurationModalClass);
export default SyncConfigurationModal;
